import { useSelector } from 'react-redux';
import {
  Container,
  DateInfo,
  MembershipPlan,
  ProPlan,
} from './styles';

const getStatusLabel = ({ subscription }) => {
  const { type: subType } = subscription;
  return subType;
};

const getUserStatus = ({ subscription }) => {
  const { type: subType, date } = subscription;

  const subscriptionType = (expireDate) => {
    const expireDateFormated = new Date(expireDate).toLocaleDateString('en-US');

    return {
      DEMO: `You have a free membership (no subscription required), valid until ${expireDateFormated}`,
      PRO: `Your subscription will automatically renew on: ${expireDateFormated}`,
      TRIAL: `You are currently using PRO plan for free. Your trial period will end on: ${expireDateFormated}`,
      FREE: 'Please subscribe on your mobile device',
    };
  };

  return subscriptionType(date)[subType];
};

const MembershipType = ({ user }) => {
  if (!user.subscription) {
    return null;
  }

  const isFree = user.subscription.type === 'FREE';

  return (
    <Container isFree={isFree}>
      <div>
        <MembershipPlan>
          Membership plan
        </MembershipPlan>
        <DateInfo>
          {`${getUserStatus(user)}`}
        </DateInfo>
      </div>
      <ProPlan>{`${user.subscription.type} PLAN`}</ProPlan>
    </Container>
  );
};

export default MembershipType;
